const findField = (fieldInfo: any[], tag: string) =>
  fieldInfo.find((f: any) => f.field === tag);

export const getFieldLabel = (fieldInfo: any[], tag: string): string | undefined => {
  return findField(fieldInfo, tag)?.fieldLabel;
};

export const getErrorText = (fieldInfo: any[], tag: string): string | undefined => {
  return findField(fieldInfo, tag)?.helpTextLong;
};

export const getRegEx = (fieldInfo: any[], tag: string): string | undefined => {
  return findField(fieldInfo, tag)?.regEx;
};

export const getRequired = (fieldInfo: any[], tag: string): boolean => {
  return !!findField(fieldInfo, tag)?.required;
};

export const getFieldMin = (fieldInfo: any[], tag: string): string | undefined => {
  return findField(fieldInfo, tag)?.fieldMin;
};

export const getFieldMax = (fieldInfo: any[], tag: string): string | undefined => {
  return findField(fieldInfo, tag)?.fieldMax;
};

/**
 * Product-field ValidationRegEx (GFFP). Returns true when no pattern, empty value, or value matches.
 * Invalid patterns from the API do not fail validation.
 */
export const matchesValidationRegEx = (field: any, value: string): boolean => {
  const pattern = String(field?.ValidationRegEx ?? field?.validationRegEx ?? "").trim();
  if (!pattern || !String(value ?? "").trim()) return true;
  try {
    return new RegExp(pattern).test(String(value));
  } catch {
    return true;
  }
};

export const validateField = (fieldInfo: any[], tag: string, value: string): string => {
  const trimmed = value.trim();

  if (getRequired(fieldInfo, tag) && !trimmed) {
    return (getErrorText(fieldInfo, tag) || `${getFieldLabel(fieldInfo, tag) || tag} is required`
    );
  }

  const min = getFieldMin(fieldInfo, tag) ? Number(getFieldMin(fieldInfo, tag)) : undefined;
  if (min && trimmed.length > 0 && trimmed.length < min) {
    return ( getErrorText(fieldInfo, tag) || `${getFieldLabel(fieldInfo, tag) || tag} must be at least ${min} characters`
    );
  }

  const max = getFieldMax(fieldInfo, tag) ? Number(getFieldMax(fieldInfo, tag)) : undefined;
  if (max && trimmed.length > max) {
    return (getErrorText(fieldInfo, tag) || `${getFieldLabel(fieldInfo, tag) || tag} must be at most ${max} characters`
    );
  }

  const regex = getRegEx(fieldInfo, tag);
  if (regex && trimmed) {
    try {
      const re = new RegExp(regex);
      if (!re.test(trimmed)) {
        return (
          getErrorText(fieldInfo, tag) ||
          `${getFieldLabel(fieldInfo, tag) || tag} contains invalid characters`
        );
      }
    } catch {
      return getErrorText(fieldInfo, tag) || "Invalid format";
    }
  }

  return "";
};
